// extracted by mini-css-extract-plugin
export default {"fullSizeImage":"tserWrD4jySTWNyiUZGQ","navButton":"e1FsAYtKTF9YjcTlytDQ","prevButton":"g3hG2Ld4lyECVzBJ131k","nextButton":"FBYR1EStWM_OKNLCn66P"};